import { identityClient } from './identityClient.js';
import { configureIdentityServer } from './identityServerClient.js';
import { configureIdentityKeyStore, configureIdentityStorage } from '../adapters/ports.js';

/**
 * Point this lib at its backends, and give it a place to store the session and
 * the key that session is bound to. One call from a host's entry point.
 *
 * @param {Object} config
 * @param {string}   [config.baseUrl]        Origin for /session/* calls. May be relative (a dev proxy's `/api`).
 * @param {Function} [config.authHeader]     async ({ method, url }) => headers, merged into every identity request.
 * @param {Function} [config.onUnauthorized] Called with the error on a 401.
 * @param {Object}   [config.identityServer] { baseUrl, appId } — where a person signs in, and which app this is.
 * @param {Object}   [config.storage]        get/set/remove driver for the session; defaults to in-memory.
 * @param {Object}   [config.keyStore]       get/set/remove driver for the proof key; defaults to IndexedDB where it exists.
 */
export function configureIdentityClient({ baseUrl, authHeader, onUnauthorized, identityServer, storage, keyStore } = {}) {
    if (baseUrl !== undefined) identityClient.baseUri = baseUrl;
    if (authHeader !== undefined) identityClient.customHeaderFn = authHeader;
    if (onUnauthorized !== undefined) identityClient.onUnauthorized = onUnauthorized;
    if (identityServer !== undefined) configureIdentityServer(identityServer);
    if (storage !== undefined) configureIdentityStorage(storage);
    if (keyStore !== undefined) configureIdentityKeyStore(keyStore);
    return { baseUrl: identityClient.baseUri };
}
